import React from "react";
import { Form } from "antd";
import TextArea from "antd/lib/input/TextArea";

const UIFormTextArea = ({
  label,
  name,
  required,
  rules,
  onChange,
  validateStatus,
  defaultValue,
  hasFeedback,
  help,
  disabled,
  placeholder = "",
  rows,
  source
}) => {
  const empInputStyle = {
    padding: "12px",
    fontWeight: "500",
    border: "1px solid #e5e7eb",
    borderRadius: 22,
    height: 150,
    display: "flex",
    alignItems: "center",
    boxShadow: "0 12px 35px rgba(15, 23, 42, 0.04)",
  }
  return (
    <Form.Item
      label={label}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue}
    >
      <TextArea
        rows={rows}
        onChange={onChange}
        disabled={disabled}
        style={ source == "employer" ? empInputStyle : {height: 150}}
        placeholder={placeholder}
      />
    </Form.Item>
  );
};
export default UIFormTextArea;
